import { mobileAppLoginUrl } from '@/lib/mobileAppLink';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function MobileReady() {
  const appUrl = mobileAppLoginUrl(navigator.userAgent, window.location.origin);
  return <main className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
    <Card className="w-full max-w-md">
      <CardHeader><CardTitle>Your account is ready</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <p>Your password is saved. Return to ReActor and sign in with your email and new password.</p>
        <Button asChild className="w-full"><a href={appUrl}>Open ReActor</a></Button>
        <p className="text-sm text-muted-foreground">Tap Open ReActor to return to the app. If it is not installed, contact your office for installation instructions.</p>
        <a className="text-sm underline" href="/login">Back to web login</a>
      </CardContent>
    </Card>
  </main>;
}
